'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { SvgManual } from '@common/icon';
import { cn } from '@core/utils';
import type { DetailHomeInstitutionResponse, ListHomeGiftProductByInstitutionResponse } from '@generated/unauth';
import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { CustomLink } from '@/app/_components/CustomLink';
import { PageNavigation } from '@/components/client';
import { DONATION_ROUTES } from '@/constants';
import { useEventListTotalCount } from '../_hooks/useEventListTotalCount';
import { HOMETOWNS_DETAIL_TAB } from '../constants';
import { AppBack } from './AppBack';
import { BenefitsContent } from './BenefitsContent';
import { ContentsContent } from './ContentsContent';
import { GiftsContent } from './GiftsContent';
import { HometownsTab } from './HometownsTab';
import { MainInfoSection } from './MainInfoSection';
import { PolicyContent } from './PolicyContent';
import { ProjectsContent } from './ProjectsContent';
import { ReviewsContent } from './ReviewsContent';
const SectionSpinner = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="py-40 flex-center"><Spinner /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface HometownsDetailTemplateProps {
  institutionId: number;
  institutionData: DetailHomeInstitutionResponse;
  giftProductData?: ListHomeGiftProductByInstitutionResponse;
  hasProjects: boolean;
  hasContents: boolean;
  hasPolicy: boolean;
  hasReviews: boolean;
}
export const HometownsDetailTemplate = t0 => {
  const $ = _c(46);
  const {
    institutionId,
    institutionData,
    giftProductData,
    hasProjects,
    hasContents,
    hasPolicy,
    hasReviews
  } = t0;
  const {
    data: benefitsCount
  } = useEventListTotalCount(institutionId);
  const hasBenefits = (benefitsCount ?? 0) > 0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppBack />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PageNavigation donationHomeButton={true} isNotUsedHomeButton={true}><CustomLink href={DONATION_ROUTES.GUIDE.pathname} aria-label={"\uAC00\uC774\uB4DC \uD398\uC774\uC9C0\uB85C \uC774\uB3D9"}><SvgManual className="size-24 text-Gray-900" /></CustomLink></PageNavigation>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== institutionData.backgroundVideoImageUrl || $[3] !== institutionData.description || $[4] !== institutionData.institutionName || $[5] !== institutionData.logoUrl || $[6] !== institutionData.pcBackgroundVideoImageUrl || $[7] !== institutionData.summary || $[8] !== institutionId) {
    t3 = <MainInfoSection title={institutionData.institutionName} summary={institutionData.summary} description={institutionData.description} institutionId={institutionId} backgroundVideoImageUrl={institutionData.backgroundVideoImageUrl} pcBackgroundVideoImageUrl={institutionData.pcBackgroundVideoImageUrl} logoUrl={institutionData.logoUrl} />;
    $[2] = institutionData.backgroundVideoImageUrl;
    $[3] = institutionData.description;
    $[4] = institutionData.institutionName;
    $[5] = institutionData.logoUrl;
    $[6] = institutionData.pcBackgroundVideoImageUrl;
    $[7] = institutionData.summary;
    $[8] = institutionId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("sticky top-0 z-10 mt-40 bg-transparent px-40 content-container", "mobile-tablet:mt-24 mobile-tablet:px-0");
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== hasBenefits || $[12] !== hasContents || $[13] !== hasPolicy || $[14] !== hasProjects || $[15] !== hasReviews) {
    t5 = filterTabs({
      hasProjects,
      hasContents,
      hasPolicy,
      hasReviews,
      hasBenefits
    });
    $[11] = hasBenefits;
    $[12] = hasContents;
    $[13] = hasPolicy;
    $[14] = hasProjects;
    $[15] = hasReviews;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t5) {
    t6 = <header className={t4}><HometownsTab tabs={t5} /></header>;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== giftProductData || $[20] !== institutionId) {
    t7 = giftProductData && giftProductData.totalCount > 0 ? <section id={HOMETOWNS_DETAIL_TAB.GIFTS} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><ErrorBoundary fallback={null}><Suspense fallback={<SectionSpinner />}><GiftsContent institutionId={institutionId} initialData={giftProductData.contents} /></Suspense></ErrorBoundary></section> : null;
    $[19] = giftProductData;
    $[20] = institutionId;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== hasProjects || $[23] !== institutionId) {
    t8 = hasProjects ? <section id={HOMETOWNS_DETAIL_TAB.PROJECTS} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><ProjectsContent institutionId={institutionId} /></section> : null;
    $[22] = hasProjects;
    $[23] = institutionId;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== hasContents || $[26] !== institutionId) {
    t9 = hasContents ? <section id={HOMETOWNS_DETAIL_TAB.CONTENTS} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><ContentsContent institutionId={institutionId} /></section> : null;
    $[25] = hasContents;
    $[26] = institutionId;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== hasPolicy || $[29] !== institutionId) {
    t10 = hasPolicy ? <section id={HOMETOWNS_DETAIL_TAB.POLICY} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><PolicyContent institutionId={institutionId} /></section> : null;
    $[28] = hasPolicy;
    $[29] = institutionId;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== hasReviews || $[32] !== institutionId) {
    t11 = hasReviews ? <section id={HOMETOWNS_DETAIL_TAB.REVIEWS} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><ErrorBoundary fallback={null}><Suspense fallback={<SectionSpinner />}><ReviewsContent institutionId={institutionId} /></Suspense></ErrorBoundary></section> : null;
    $[31] = hasReviews;
    $[32] = institutionId;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== hasBenefits || $[35] !== institutionId) {
    t12 = hasBenefits ? <section id={HOMETOWNS_DETAIL_TAB.BENEFITS} className={cn("mb-80 px-40 content-container", "mobile-tablet:mb-56 mobile-tablet:px-20")}><BenefitsContent institutionId={institutionId} /></section> : null;
    $[34] = hasBenefits;
    $[35] = institutionId;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t10 || $[38] !== t11 || $[39] !== t12 || $[40] !== t3 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t13 = <div className="relative">{t1}{t2}{t3}{t6}{t7}{t8}{t9}{t10}{t11}{t12}</div>;
    $[37] = t10;
    $[38] = t11;
    $[39] = t12;
    $[40] = t3;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  return t13;
};
const filterTabs = ({
  hasProjects,
  hasContents,
  hasPolicy,
  hasReviews,
  hasBenefits
}: {
  hasProjects: boolean;
  hasContents: boolean;
  hasPolicy: boolean;
  hasReviews: boolean;
  hasBenefits: boolean;
}) => {
  const tabs: ({
    title: string;
    tab: HOMETOWNS_DETAIL_TAB;
  } | null)[] = [{
    title: '답례품',
    tab: HOMETOWNS_DETAIL_TAB.GIFTS
  }, hasProjects ? {
    title: '지정기부',
    tab: HOMETOWNS_DETAIL_TAB.PROJECTS
  } : null, hasContents ? {
    title: '콘텐츠',
    tab: HOMETOWNS_DETAIL_TAB.CONTENTS
  } : null, hasPolicy ? {
    title: '정책',
    tab: HOMETOWNS_DETAIL_TAB.POLICY
  } : null, hasReviews ? {
    title: '후기',
    tab: HOMETOWNS_DETAIL_TAB.REVIEWS
  } : null, hasBenefits ? {
    title: '혜택',
    tab: HOMETOWNS_DETAIL_TAB.BENEFITS
  } : null];
  return tabs.filter((tab): tab is {
    title: string;
    tab: HOMETOWNS_DETAIL_TAB;
  } => Boolean(tab));
};